// menuType: { "1": "类别", "2": "单项", "3": "按钮", "4": "模块" }, //菜单类型
// menuStatus: { "1": "展开", "2": "不展开", "3": "隐藏" }, //菜单类型

const dynamicRoutes = [
  {
    menuName: "工作台",
    menuType: 1,
    status: 1,
    menuPage: "/work",
    componentPath: "/layout/home",
    children: [
      {
        menuName: "首页",
        menuIcon: "home",
        menuType: 1,
        status: 2,
        menuPage: "/work/home/index",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "首页",
            menuType: 2,
            status: 2,
            menuPage: "/work/home/index",
            componentPath: "/workbenchHome/index"
          },
          {
            menuName: "个人中心",
            menuType: 2,
            status: 3,
            menuPage: "/work/mine",
            componentPath: "/userInfo/index"
          }
        ]
      },
      {
        menuName: "房源管理",
        menuIcon: "house",
        menuType: 1,
        status: 1,
        menuPage: "/work/house",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "新房",
            menuType: 2,
            status: 2,
            menuPage: "/work/house/new",
            componentPath: "/house/new/index/index"
          },
          {
            menuName: "新房详情",
            menuType: 2,
            status: 3,
            menuPage: "/work/newHouse/detail/:id",
            componentPath: "/house/new/detail/index"
          },
          {
            menuName: "二手房",
            menuType: 2,
            status: 2,
            menuPage: "/work/house/old",
            componentPath: "/house/old/index/index"
          },
          {
            menuName: "租赁",
            menuType: 2,
            status: 2,
            menuPage: "/work/house/rental",
            componentPath: "/house/old/index/index"
          },
          {
            menuName: "买卖房源详情",
            menuType: 2,
            status: 3,
            menuPage: "/work/house/old/detail/:id",
            componentPath: "/house/old/detail/index"
          },
          {
            menuName: "录入买卖房源",
            menuType: 2,
            status: 3,
            menuPage: "/work/house/old/edit/:id",
            componentPath: "/house/old/edit/index"
          },
          {
            menuName: "租赁房源详情",
            menuType: 2,
            status: 3,
            menuPage: "/work/house/rental/detail/:id",
            componentPath: "/house/old/detail/index"
          },
          {
            menuName: "录入租赁房源",
            menuType: 2,
            status: 3,
            menuPage: "/work/house/rental/edit/:id",
            componentPath: "/house/old/edit/index"
          },
          {
            menuName: "小区",
            menuType: 2,
            status: 2,
            menuPage: "/work/house/community",
            componentPath: "/house/community/index/index"
          },
          {
            menuName: "小区详情",
            menuType: 2,
            status: 3,
            menuPage: "/work/house/communityDetail/:id",
            componentPath: "/house/community/detail/index"
          },
          {
            menuName: "创建小区",
            menuType: 2,
            status: 3,
            menuPage: "/work/house/communityEdit",
            componentPath: "/house/community/edit/index"
          }
        ]
      },
      {
        menuName: "客源管理",
        menuIcon: "user-setting",
        menuType: 1,
        status: 1,
        menuPage: "/work/crm",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "全部客户",
            menuType: 2,
            status: 2,
            menuPage: "/work/crm/customer",
            componentPath: "/crm/customer/index"
          },
          {
            menuName: "线索池",
            menuType: 2,
            status: 2,
            menuPage: "/work/crm/clue",
            componentPath: "/crm/clue/index"
          },
          {
            menuName: "批量新增线索",
            menuType: 2,
            status: 3,
            menuPage: "/work/crm/clue/edit",
            componentPath: "/crm/clue/children/clueEdit"
          }
        ]
      },
      {
        menuName: "签约交易",
        menuIcon: "order",
        menuType: 1,
        status: 1,
        menuPage: "/work/business",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "新房成交",
            menuType: 2,
            status: 2,
            menuPage: "/work/business/newHouse",
            componentPath: "/business/newHouse/index"
          },
          {
            menuName: "成交详情",
            menuType: 2,
            status: 3,
            menuPage: "/work/business/newHouse/dealDetail/:id",
            componentPath: "/business/newHouse/children/detail"
          },
          {
            menuName: "申报客户成交",
            menuType: 2,
            status: 3,
            menuPage: "/work/business/newHouse/editDeal/:id",
            componentPath: "/business/newHouse/children/editDeal"
          },
          {
            menuName: "业绩管理",
            menuType: 2,
            status: 2,
            menuPage: "/work/business/achievement",
            componentPath: "/business/achievement/index"
          },
          {
            menuName: "提成管理",
            menuType: 2,
            status: 2,
            menuPage: "/work/business/commission",
            componentPath: "/business/commission/index"
          },
          {
            menuName: "二手房成交",
            menuType: 2,
            status: 2,
            menuPage: "/work/business/dealContract",
            componentPath: "/business/contract/index"
          },
          {
            menuName: "租赁成交",
            menuType: 2,
            status: 2,
            menuPage: "/work/business/leaseContract",
            componentPath: "/business/contract/index"
          },
          {
            menuName: "二手房合同详情",
            menuType: 2,
            status: 3,
            menuPage: "/work/business/dealContract/detail/:id",
            componentPath: "/business/contract/children/detail"
          },
          {
            menuName: "租赁合同详情",
            menuType: 2,
            status: 3,
            menuPage: "/work/business/leaseContract/detail/:id",
            componentPath: "/business/contract/children/detail"
          },
          {
            menuName: "创建(二手房)合同",
            menuType: 2,
            status: 3,
            menuPage: "/work/business/dealContract/edit/:id",
            componentPath: "/business/contract/children/edit"
          },
          {
            menuName: "创建(租赁)合同",
            menuType: 2,
            status: 3,
            menuPage: "/work/business/leaseContract/edit/:id",
            componentPath: "/business/contract/children/edit"
          }
        ]
      },
      {
        menuName: "数据统计",
        menuIcon: "chart",
        menuType: 1,
        status: 1,
        menuPage: "/work/statistics",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "量化统计",
            menuType: 2,
            status: 2,
            menuPage: "/work/statistics/quantization",
            componentPath: "/statistics/quantization/index"
          },
          {
            menuName: "房源分析",
            menuType: 2,
            status: 2,
            menuPage: "/work/statistics/house",
            componentPath: "/statistics/house/index"
          },
          {
            menuName: "客源分析",
            menuIcon: "dictionary",
            menuType: 2,
            status: 2,
            menuPage: "/work/statistics/customer",
            componentPath: "/statistics/customer/index"
          },
          {
            menuName: "带看分析",
            menuIcon: "dictionary",
            menuType: 2,
            status: 2,
            menuPage: "/work/statistics/visit",
            componentPath: "/statistics/visit/index"
          },
          {
            menuName: "业绩统计",
            menuIcon: "dictionary",
            menuType: 2,
            status: 2,
            menuPage: "/work/statistics/performance",
            componentPath: "/statistics/performance/index"
          }
        ]
      },
      {
        menuName: "门店管理",
        menuIcon: "store",
        menuType: 1,
        status: 1,
        menuPage: "/work/store/staff",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "员工管理",
            menuType: 2,
            status: 2,
            menuPage: "/work/store/staff",
            componentPath: "/store/employee/index"
          },
          {
            menuName: "管理员工档案",
            menuType: 2,
            status: 3,
            menuPage: "/work/store/userInfo/:id",
            componentPath: "/userInfo/index"
          },
          {
            menuName: "门店费用",
            menuType: 2,
            status: 2,
            menuPage: "/work/store/cost",
            componentPath: "/store/cost/index"
          },
          {
            menuName: "财务核算",
            menuType: 2,
            status: 2,
            menuPage: "/work/store/accounting",
            componentPath: "/store/accounting/index"
          }
        ]
      },
      {
        menuName: "企业设置",
        menuIcon: "setting",
        menuType: 1,
        status: 1,
        menuPage: "/work/enterprise/store",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "店组管理",
            menuType: 2,
            status: 2,
            menuPage: "/work/enterprise/store",
            componentPath: "/enterprisesSetting/store/index"
          },
          {
            menuName: "部门管理",
            menuType: 2,
            status: 2,
            menuPage: "/work/enterprise/organograma",
            componentPath: "/enterprisesSetting/organograma/index"
          },
          {
            menuName: "岗位管理",
            menuIcon: "station",
            menuType: 2,
            status: 2,
            menuPage: "/work/enterprise/station",
            componentPath: "/enterprisesSetting/station/index"
          },
          {
            menuName: "应用管理",
            menuIcon: "station",
            menuType: 2,
            status: 2,
            menuPage: "/work/enterprise/app",
            componentPath: "/enterprisesSetting/app/index"
          },
          {
            menuName: "角色管理",
            menuIcon: "dictionary",
            menuType: 2,
            status: 2,
            menuPage: "/work/enterprise/role",
            componentPath: "/enterprisesSetting/roleManage/index"
          },
          {
            menuName: "权限设置",
            menuType: 2,
            status: 3,
            menuPage: "/work/enterprise/roleSetting/:id",
            componentPath: "/enterprisesSetting/roleSetting/index"
          },
          {
            menuName: "参数配置",
            menuType: 2,
            status: 2,
            menuPage: "/work/enterprise/dictionary",
            componentPath: "/enterprisesSetting/dictionary/index"
          }
        ]
      }
    ]
  },
  {
    menuName: "城市运营中心",
    menuType: 1,
    status: 1,
    menuPage: "/coc",
    componentPath: "/layout/home",
    children: [
      {
        menuName: "首页",
        menuIcon: "home",
        menuType: 1,
        status: 2,
        menuPage: "/coc/home",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "首页",
            menuType: 2,
            status: 2,
            menuPage: "/coc/home",
            componentPath: "/coc/home/index"
          },
          {
            menuName: "个人中心",
            menuType: 2,
            status: 3,
            menuPage: "/coc/mine",
            componentPath: "/userInfo/index"
          }
        ]
      },
      {
        menuName: "运营设置",
        menuIcon: "setting",
        menuType: 1,
        status: 1,
        menuPage: "/coc/config/role",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "团队管理",
            menuType: 2,
            status: 2,
            menuPage: "/coc/company/index",
            componentPath: "/coc/company/list/index"
          },
          {
            menuName: "经纪公司",
            menuType: 2,
            status: 3,
            menuPage: "/coc/company/brokerageDetail/:id",
            componentPath: "/coc/company/detail/brokerage"
          },
          {
            menuName: "独立经纪",
            menuType: 2,
            status: 3,
            menuPage: "/coc/company/independentDetail/:id",
            componentPath: "/coc/company/detail/independent"
          },
          {
            menuName: "伙伴组织",
            menuType: 2,
            status: 3,
            menuPage: "/coc/company/partnerDetail/:id",
            componentPath: "/coc/company/detail/partnerCompany/index"
          },
          // {
          //   menuName: "公司管理",
          //   menuType: 2,
          //   status: 2,
          //   menuPage: "/coc/config/company",
          //   componentPath: "/coc/company/manage"
          // },
          {
            menuName: "应用管理",
            menuIcon: "station",
            menuType: 2,
            status: 2,
            menuPage: "/coc/app",
            componentPath: "/enterprisesSetting/app/index"
          },
          {
            menuName: "房源角色",
            menuType: 2,
            status: 2,
            menuPage: "/coc/config/role",
            componentPath: "/coc/config/role"
          },
          {
            menuName: "区域商圈",
            menuType: 2,
            status: 2,
            menuPage: "/coc/config/areas",
            componentPath: "/coc/config/areas"
          },
          {
            menuName: "建筑类型",
            menuType: 2,
            status: 2,
            menuPage: "/coc/config/building",
            componentPath: "/coc/config/building"
          }
        ]
      },
      {
        menuName: "人事管理",
        menuIcon: "user-group",
        menuType: 1,
        status: 1,
        menuPage: "/coc/hr/staff",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "员工管理",
            menuType: 2,
            status: 2,
            menuPage: "/coc/hr/staff",
            componentPath: "/store/employee/index"
          },
          {
            menuName: "组织架构",
            menuType: 2,
            status: 2,
            menuPage: "/coc/hr/organograma",
            componentPath: "/enterprisesSetting/organograma/index"
          },
          {
            menuName: "管理员工档案",
            menuType: 2,
            status: 3,
            menuPage: "/coc/hr/userInfo/:id",
            componentPath: "/userInfo/index"
          },
          {
            menuName: "岗位管理",
            menuType: 2,
            status: 2,
            menuPage: "/coc/hr/station",
            componentPath: "/enterprisesSetting/station/index"
          },
          {
            menuName: "角色管理",
            menuType: 2,
            status: 2,
            menuPage: "/coc/hr/role",
            componentPath: "/enterprisesSetting/roleManage/index"
          },
          {
            menuName: "权限设置",
            menuType: 2,
            status: 3,
            menuPage: "/coc/hr/roleSetting/:id",
            componentPath: "/enterprisesSetting/roleSetting/index"
          }
        ]
      }
    ]
  },
  {
    menuName: "全局配置",
    menuType: 1,
    status: 1,
    menuPage: "/adminConfig",
    componentPath: "/layout/home",
    children: [
      {
        menuName: "首页",
        menuIcon: "home",
        menuType: 1,
        status: 2,
        menuPage: "/adminConfig/home",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "首页",
            menuType: 2,
            status: 2,
            menuPage: "/adminConfig/home",
            componentPath: "/coc/home/index"
          }
        ]
      },
      {
        menuName: "全局配置",
        menuIcon: "setting",
        menuType: 1,
        status: 1,
        menuPage: "/adminConfig/config/index",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "城市站点",
            menuType: 2,
            status: 2,
            menuPage: "/adminConfig/citySite",
            componentPath: "/adminConfig/citySite/index"
          },
          {
            menuName: "应用管理",
            menuIcon: "station",
            menuType: 2,
            status: 2,
            menuPage: "/adminConfig/app",
            componentPath: "/enterprisesSetting/app/index"
          },
          {
            menuName: "团队管理",
            menuType: 2,
            status: 2,
            menuPage: "/adminConfig/company",
            componentPath: "/coc/company/list/index"
          },
          {
            menuName: "经纪公司",
            menuType: 2,
            status: 3,
            menuPage: "/adminConfig/company/brokerageDetail/:id",
            componentPath: "/coc/company/detail/brokerage"
          },
          {
            menuName: "独立经纪",
            menuType: 2,
            status: 3,
            menuPage: "/adminConfig/company/independentDetail/:id",
            componentPath: "/coc/company/detail/independent"
          },
          {
            menuName: "伙伴组织",
            menuType: 2,
            status: 3,
            menuPage: "/adminConfig/company/partnerDetail/:id",
            componentPath: "/coc/company/detail/partnerCompany/index"
          },
          // {
          //   menuName: "公司管理",
          //   menuType: 2,
          //   status: 2,
          //   menuPage: "/adminConfig/company",
          //   componentPath: "/coc/company/manage"
          // },
          {
            menuName: "路由配置",
            menuType: 2,
            status: 2,
            menuPage: "/adminConfig/menu",
            componentPath: "/adminConfig/menu/index"
          },
          {
            menuName: "管理员工档案",
            menuType: 2,
            status: 3,
            menuPage: "/adminConfig/userInfo/:id",
            componentPath: "/userInfo/index"
          }
        ]
      },
      {
        menuName: "AI助手",
        menuIcon: "bubble",
        menuType: 1,
        status: 1,
        menuPage: "/adminConfig/aiHelper",
        componentPath: "/layout/subView",
        children: [
          {
            menuName: "对话助手",
            menuType: 2,
            status: 2,
            menuPage: "/adminConfig/aiHelper/dialog",
            componentPath: "/aiHelper/dialog/index/index"
          },
          {
            menuName: "对话助手详情",
            menuType: 2,
            status: 3,
            menuPage: "/adminConfig/aiHelper/dialog/detail",
            componentPath: "/aiHelper/dialog/detail/index"
          },
          {
            menuName: "创作助手",
            menuType: 2,
            status: 2,
            menuPage: "/adminConfig/aiHelper/creation",
            componentPath: "/aiHelper/creation/index/index"
          },
          {
            menuName: "创作助手详情",
            menuType: 2,
            status: 3,
            menuPage: "/adminConfig/aiHelper/creation/detail",
            componentPath: "/aiHelper/creation/detail/index"
          },
          {
            menuName: "知识库",
            menuType: 2,
            status: 2,
            menuPage: "/adminConfig/aiHelper/knowledge",
            componentPath: "/aiHelper/knowledge/index/index"
          },
          {
            menuName: "知识库详情",
            menuType: 2,
            status: 3,
            menuPage: "/adminConfig/aiHelper/knowledge/detail",
            componentPath: "/aiHelper/knowledge/detail/index"
          }
        ]
      }
    ]
  }
];

export default dynamicRoutes;
